module.exports = window['react/jsx-runtime'];